import axios from "axios";
import url from "../urls";

export default {
  //put
  add(context, data) {
    return new Promise((resolve, reject) => {
      let addUrl = url.StudentTestUrl;
      axios
        .put(addUrl, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
  //get
  get(context, data) {
    return new Promise((resolve, reject) => {
      let getUrl = url.GetAllTestByStudentIdUrl;

      axios
        .get(getUrl, {
          params: data,
        })
        .then((response) => {
          //console.log("question got");
          //context.commit("mutateCompletionQuestions", response.data);
          console.log(response);
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
  //get
  getTestById(context, data) {
    return new Promise((resolve, reject) => {
      let getUrl = url.GetTestByIdUrl;
      axios
        .get(getUrl, {
          params: data,
        })
        .then((response) => {
          //console.log("question got");
          //context.commit("mutateCompletionQuestions", response.data);
          console.log(response);
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
  //get
  getAllTestByStudentId(context, data) {
    return new Promise((resolve, reject) => {
      let getUrl = url.GetAllTestByStudentIdUrl;

      axios
        .get(getUrl, {
          params: {
            userId: data.userId,
          },
        })
        .then((response) => {
          //过滤掉还未publish给学生的测试
          if (data.userRole == "Student") {
            response.data = response.data.filter((el) => el.published == true);
          }
          context.commit("mutateTestList", response.data);
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
  //get
  getAllTestsByUserId(context, data) {
    return new Promise((resolve, reject) => {
      let getUrl = url.GetAllTestsByUserIdUrl;

      axios
        .get(getUrl, {
          params: {
            userId: data.userId,
          },
        })
        .then((response) => {
          context.commit("mutateTestList", response.data);
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
  //post
  createEditStudentTest(context, data) {
    return new Promise((resolve, reject) => {
      let editUrl = url.StudentTestUrl;
      axios
        .post(editUrl, data)
        .then((response) => {
          console.log(response);
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  },

  //post
  publishStudentTest(context, data) {
    return new Promise((resolve, reject) => {
      let editUrl = url.StudentTestUrl;
      axios
        .post(editUrl, data)
        .then((response) => {
          console.log(response);
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
  //post
  editVocStudentTestVocabularyAnswer(context, data) {
    return new Promise((resolve, reject) => {
      let editUrl = url.EditVocStudentTestVocabularyAnswer;
      axios
        .post(editUrl, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
  //post
  correctStudentAudioAnswer(context, data) {
    return new Promise((resolve, reject) => {
      let editUrl = url.CorrectStudentAudioAnswer;
      console.log(editUrl)
      console.log(data)
      axios
        .post(editUrl, null, {params: data})
        .then((response) => {
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  },

  //post
  // 生产环境 nginx 对约 >11KB 的 POST 体会直接 500 且不带 CORS 头；
  // Evian List12-16 等大批量词会踩中，故按批提交。
  addVocabularyAnswers(context, data) {
    const answers = Array.isArray(data) ? data : [];
    const addUrl = url.AddVocabularyAnswersUrl;
    // 单条约 60–80 字节，80 条约 5–7KB，远低于网关阈值
    const CHUNK_SIZE = 80;

    if (answers.length === 0) {
      return Promise.resolve({ data: true });
    }

    if (answers.length <= CHUNK_SIZE) {
      return axios.post(addUrl, answers);
    }

    const chunks = [];
    for (let i = 0; i < answers.length; i += CHUNK_SIZE) {
      chunks.push(answers.slice(i, i + CHUNK_SIZE));
    }

    return chunks
      .reduce(
        (chain, chunk) =>
          chain.then(() =>
            axios.post(addUrl, chunk).then((response) => {
              if (response.data === false) {
                return Promise.reject(
                  new Error("部分词汇写入失败，请重试或减少词量")
                );
              }
              return response;
            })
          ),
        Promise.resolve()
      )
      .then(() => ({ data: true }));
  },
  //post
  updateStudentTestStatus(context, data) {
    return new Promise((resolve, reject) => {
      let editUrl = url.StudentTestUrl;
      axios
        .post(editUrl, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
  //post
  edit(context, data) {
    return new Promise((resolve, reject) => {
      let editUrl = url.StudentTestUrl;
      axios
        .post(editUrl, data)
        .then((response) => {
          console.log(response);
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  },

  //post
  createDuplicatedTest(context, data) {
    return new Promise((resolve, reject) => {
      let createDuplicatedTestUrl = url.CreateDuplicatedTestUrl;
      axios
        .post(createDuplicatedTestUrl, data)
        .then((response) => {
          console.log(response);
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  },

  //delete
  delete(context, data) {
    return new Promise((resolve, reject) => {
      let deleteUrl = url.StudentTestUrl;
      axios
        .delete(deleteUrl, { params: data })
        .then((response) => {
          console.log(response);
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
};
